import CryptoJS from 'crypto-js'

const SECRET_KEY = process.env.VUE_APP_STORAGE_KEY

const encode = (str) => CryptoJS.AES.encrypt(str, SECRET_KEY).toString()
const decode = (str) => CryptoJS.AES.decrypt(str, SECRET_KEY).toString(CryptoJS.enc.Utf8)

export function storageSet(key, value) {
	localStorage.setItem(key, encode(String(value)))
}

export function storageGet(key) {
	const item = localStorage.getItem(key)
	if (!item) return null
	try {
		return decode(item)
	} catch {
		return null
	}
}

export function storageRemove(key) {
	localStorage.removeItem(key)
}
